import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { HourlyTuitionDiscountType } from './hourly-tuition.constants';

export interface SaveDraftRequest {
  sessionId: string;
  fromDate: string;
  toDate: string;
  studentId: string;
  discountType: HourlyTuitionDiscountType;
  discount: number;
  isScheduledPayment?: boolean;
  scheduledDate?: string;
}

export interface SaveDraftResponse {
  success: boolean;
  draftId: string;
  message: string;
  data: {
    studentId: string;
    studentName: string;
    totalTuition: number;
    discountApplied: number;
    finalAmount: number;
    discountType: string;
    discount: number;
    isScheduledPayment: boolean;
    scheduledDate: string | null;
  };
}

// Save draft API
export const saveDraftAPI = async (
  data: SaveDraftRequest,
): Promise<SaveDraftResponse> => {
  const response = await baseAPI.post('/hourly-tuition-billing/draft', data);
  return response.data;
};

// React Query hook
export const useSaveDraft = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveDraftAPI,
    onSuccess: () => {
      // Invalidate all session billing breakdown queries to refresh data
      queryClient.invalidateQueries({
        predicate: (query) => {
          return (
            query.queryKey[0] === KEYS.HOURLY_TUITION_BILLING &&
            query.queryKey[1] === KEYS.SESSION_BILLING_BREAKDOWN
          );
        },
      });
    },
  });
};
